import { render, staticRenderFns } from "./RevenueProduct.vue?vue&type=template&id=6171ea18&scoped=true&"
import script from "./RevenueProduct.vue?vue&type=script&lang=js&"
export * from "./RevenueProduct.vue?vue&type=script&lang=js&"
import style0 from "./RevenueProduct.vue?vue&type=style&index=0&id=6171ea18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171ea18",
  null
  
)

export default component.exports